import { render } from "./LoadingScreen.vue?vue&type=template&id=24bec42e"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"
script.render = render

export default script